export const STORAGE_KEYS = {
  ONBOARDING_DATA: 'onboarding_data',
} as const;
